// removed by extract-text-webpack-plugin
module.exports = {"image":"_2pRru"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/CoverImage.scss
// module id = ./src/components/Page/CoverImage.scss
// module chunks = 5